export edhDark from './edh-logo.svg'
export edhLight from './edh-logo-light.svg'
export edhLogo from './edh-logomark.svg'
export jgDark from './jg-logo.svg'
export jgLight from './jg-logo-light.svg'
export jgLogo from './jg-logomark.svg'



// WEBPACK FOOTER //
// ./assets/index.js